// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"secondary-navbar-mobile_wrapper__j2vAa","searchBarClass":"secondary-navbar-mobile_searchBarClass__MLQcz","navToggle":"secondary-navbar-mobile_navToggle__K__D9"};